import './Footer.css';
import Analytics from './Analytics';

function Footer() {
    return (        
        <div className='footer'>            
            <div className='copyright'>
                <span>© 2023 Accenture. All Rights Reserved. Accenture Confidential. For internal use only. Powered by Learning Integrated Services - LKM, ATCI.</span>
            </div>            
            <Analytics />
        </div>                       
    )
}

export default Footer